import React, { FC } from 'react'

import { Tag, Text } from '@babylon/core-ui'

import { isFilledArray } from '~/core'
import { useMessages } from '~/core/hooks'
import { AppointmentInvitesQueryResult } from '~/generated'

import styles from './styles.module.scss'
import messages from './TimelineFollowUpActions.messages'

interface Props {
  appointmentInvites: NonNullable<
    NonNullable<AppointmentInvitesQueryResult['data']>['consultation']
  >['appointmentInvites']
}

const TimelineFollowUpActions: FC<Props> = ({ appointmentInvites }) => {
  const f = useMessages(messages)

  const hasAppointmentInvites = isFilledArray(appointmentInvites)

  return (
    <>
      {hasAppointmentInvites && (
        <div className={styles.workflowGroup}>
          <Text className={styles.completeTimelineActionLabel}>
            {f('appointment_invites_label')}
          </Text>
          {appointmentInvites?.map(({ id, service_type: serviceType }) => (
            <Tag className={styles.followUpclinicalCode} key={id}>
              {serviceType?.name ?? f('no_service_type')}
            </Tag>
          ))}
        </div>
      )}
    </>
  )
}

export default TimelineFollowUpActions
